<template>
  <div>
    <Topbar />
    <Sidebar />
    <div class="app-content content" style="min-height: 90vh;">
      <div class="content-overlay"></div>
      <div class="content-wrapper">
        <Alert @click="docusignGrantAccess()" v-if="needsConsent" docusign="true" dismissable="true"
          :text="$t('DocuSign validation')" type="danger" />
        <router-view />
      </div>
      <div class="modal fade text-left" id="session-expired-popup" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true" v-if="sessionData">
      <div class="modal-dialog modal-lg modalPopStyle" role="document">
        <div class="modal-content resetPasswordDialogue">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{
              $t('users_module_invite_success_popup_heading')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title" id="create-modal-title">{{
              $t('users_module_success_invitation_popup_message')
            }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('users_module_invitation_success_popup_ok_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Alert from '@/components/Alerts'
import Topbar from '@/components/Topbar'
import Sidebar from '@/components/Sidebar'
import Footer from '@/components/Footer'
export default {
  name: 'AppLayout',
  components: {
    Topbar,
    Sidebar,
    Footer,
    Alert
  },
  data() {
    return {
      needsConsent: false,
      sessionData: false
    }
  },

  computed: {
    docusignAuth: function () {
      return localStorage.getItem('dTok')
    }
  },

  methods: {
    checkDocusignConsent() {
      this.$apiCall.get("/v1/docusign/needsConsent")
        .then(response => {
          this.needsConsent = response?.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getSessionData(){
      let self = this;
      self.sessionData = localStorage.getItem('session');
      if(self.sessionData){
        this.$('#session-expired-popup').modal()
      }

    }
  },

  mounted() {
    this.checkDocusignConsent();
  },

  created() {
    this.$apiCall.get(`/v1/me`)
      .then(res => {
        const user = res.data;
        this.$getToken()
          .then(currentToken => {
            if (!user.webTokens || !user.webTokens.length) {
              this.$apiCall.put(`/v1/me/notifications/web?token=${currentToken}`);
            } else {
              if (!user.webTokens.includes(currentToken)) {
                this.$apiCall.put(`/v1/me/notifications/web?token=${currentToken}`);
              }
            }
          })
          .catch(err => {
            console.log('token', err)
            if (user.webTokens) {
              user.webTokens.map(token => {
                this.$apiCall.delete(`/v1/me/notifications/web?token=${token}`);
              })
            }
          })
      })
      .catch(err => {
        console.log(err);
      })
  }
}
</script>

<style>
.capitalize {
  text-transform: capitalize;
}

.select2-search__field:focus {
  outline: none;
}

.select2-selection.select2-selection--single:focus {
  outline: none;
  border-color: #5A8DEE;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
}

.select2-container--default .select2-selection--single {
  border: 1px solid #DFE3E7;
}

.iti__selected-flag:focus {
  outline: none;
}

small {
  font-size: 12px !important;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
  font-size: 15px !important;
}

.alert {
  font-size: 15px !important;
}

.picker__table td {
  font-size: 15px !important;
}

.mt-chrome {
  margin-top: -5px !important;
}

.mt-firefox {
  margin-top: -3px !important;
}

.scrollable-screen {
  z-index: 9999999;
  padding-top: 20px;
  margin-top: -150px;
  width: 100%;
  height: fit-content;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 8px 5px 0px rgb(25 42 70 / 13%);
  left: 260px;
  position: fixed;
  padding-right: 260px;
  padding-bottom: 50px;
}

@media(max-width: 1200px) {
  .scrollable-screen {
    left: 0;
    padding-right: 0;
  }
}
</style>
